import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    Skeleton,
    useMediaQuery,
    useTheme
} from "@mui/material";
import { useTranslation } from 'react-i18next';


const RouteVehicleStatusTable = ({
    loading,
    error,
    vehicleData,
    formatDistance,
    formatTime,
    getVehicleNameByDeviceId,
    sx = {},
    tableMinWidth,
    size = "medium",
}) => {
    console.log(vehicleData)
    const { t } = useTranslation()
    const sortedVehicles = Object.values(vehicleData)
        .sort((a, b) => {
            const distA = parseFloat(a.distance);
            const distB = parseFloat(b.distance);
            if (isNaN(distA) && isNaN(distB)) return 0;
            if (isNaN(distA)) return 1;
            if (isNaN(distB)) return -1;
            return distA - distB;
        });
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    console.log(sortedVehicles)
    return (
        <Box sx={{
            borderRadius: "10px",
            padding: { xs: "10px", sm: "15px", md: "20px" },
            backgroundColor: "#FFFFFF",
            border: "1px solid #A5DCF3",
            margin: { xs: "10px 15px", sm: "15px 20px", md: "20px 40px" },
            ...sx,
        }}>
            <TableContainer elevation={3}>
                <Table
                    size={size}
                    sx={{
                        borderCollapse: 'separate',
                        borderSpacing: 0,
                        minWidth: tableMinWidth || (isMobile ? "100%" : "650px"), // Set minimum width for better mobile handling
                    }}
                    aria-label="vehicle table"
                >
                    <TableHead>
                        <TableRow style={{ backgroundColor: "#647490", color: "white" }}>
                            <TableCell
                                sx={{
                                    fontWeight: 'bold',
                                    backgroundColor: '#647490',
                                    fontSize: '1rem',
                                    color: "white",
                                    borderTopLeftRadius: "8px",
                                    borderBottomLeftRadius: "8px"
                                }}
                            >
                                {t("Vehicle Name")}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#647490', fontSize: '1rem', color: "white" }}>
                                {t("Distance Left")}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#647490', fontSize: '1rem', color: "white" }}>
                                {t("ETA")}
                            </TableCell>
                            <TableCell
                                sx={{
                                    fontWeight: 'bold',
                                    backgroundColor: '#647490',
                                    fontSize: '1rem',
                                    color: "white",
                                    borderTopRightRadius: "8px",
                                    borderBottomRightRadius: "8px"
                                }}
                            >
                                {t("Speed")} (km/h)
                            </TableCell>
                            {/* <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#647490', fontSize: '1rem', color: "white" }}>
                                {t("Temperature")}(°C)
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#647490', fontSize: '1rem', color: "white" }}>
                                {t("Satellites")}
                            </TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            [...Array(5)].map((_, index) => (
                                <TableRow key={`vehicle-status-skeleton-${index}`}>
                                    {[...Array(4)].map((__, cellIndex) => (
                                        <TableCell key={cellIndex}>
                                            <Skeleton height={24} width={cellIndex === 0 ? "80%" : "60%"} />
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))
                        ) : error ? (
                            <TableRow>
                                <TableCell colSpan={6} sx={{ textAlign: 'center', color: 'error.main', py: 2 }}>
                                    {error}
                                </TableCell>
                            </TableRow>
                        ) : sortedVehicles.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={6} sx={{ textAlign: 'center', py: 2 }}>
                                    {t("No vehicle data available")}
                                </TableCell>
                            </TableRow>
                        ) : (
                            sortedVehicles.map((data) => (
                                <TableRow
                                    key={data.device_id}
                                    sx={{
                                        '&:nth-of-type(odd)': {
                                            backgroundColor: '#fafafa',
                                        },
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                        },
                                    }}
                                >
                                    {/* <TableCell sx={{ fontWeight: '500' }}>{data.device_id}</TableCell> */}
                                    <TableCell sx={{ fontWeight: '500' }}>{getVehicleNameByDeviceId(data.device_id)}</TableCell>
                                    <TableCell>
                                        {isNaN(Number(data.distance)) ? data.distance : Number(data.distance).toFixed(2)}
                                    </TableCell>
                                    <TableCell>
                                        {isNaN(Number(data.eta))
                                            ? data.eta
                                            : (() => {
                                                const totalSeconds = Number(data.eta);
                                                const mins = Math.floor(totalSeconds / 60);
                                                const secs = (totalSeconds % 60).toFixed(2);
                                                return `${mins}m ${secs}s`;
                                            })()
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {isNaN(Number(data.speed)) ? data.speed : Number(data.speed).toFixed(2)}
                                    </TableCell>
                                    {/* <TableCell>{data.temperature || "N/A"}</TableCell>
                                    <TableCell>{data.satellites || "N/A"}</TableCell> */}
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default RouteVehicleStatusTable;
